import { useQuery } from '@tanstack/react-query'
import { UserGroup, UsersApi } from '@ulysses-inc/harami_api_client'
import { PaginationState } from 'src/hooks/useListPagination'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export type UserGroupsQueryResult = {
  userGroups: UserGroup[]
  count: number
}

export const useQueryUserGroups = (filters: PaginationState) => {
  return useQuery({
    queryKey: queryKeys.userGroups(filters),
    queryFn: async () => {
      return await baseClient
        .getApi(UsersApi)
        .getUserGroups({
          limit: filters.pageSize,
          offset: (filters.page - 1) * filters.pageSize,
        })
        .catch(handleHTTPError)
    },
    select: (data): UserGroupsQueryResult => ({
      userGroups: data.userGroups ?? [],
      count: data.count ?? 0,
    }),
  })
}
